export const ITEM_HEIGHT = 48;
export const ITEM_PADDING_TOP = 8;
export const ITEM_WIDTH = 200;
export const CUSTOM_LABEL = 'MuiCustomLabel';
export const CUSTOM_FORM_LABEL = 'MuiCustomFormLabel';
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};
